import type { HierarchyRectangularNode } from 'd3-hierarchy';

import type { ClusterNode, LeafNode } from '../types/guards/node-guards.js';
import type { InternalTreeMapNode } from '../types/internal.js';

export const splitNodesByDepth = (
  nodes: HierarchyRectangularNode<InternalTreeMapNode>[],
) => {
  const splitNodes: {
    clusters: HierarchyRectangularNode<ClusterNode>[];
    leafs: HierarchyRectangularNode<LeafNode>[];
  } = { clusters: [], leafs: [] };

  return nodes.reduce((acc, node) => {
    if (node.depth === 1) {
      acc.clusters.push(node as HierarchyRectangularNode<ClusterNode>);
    }
    if (node.depth > 1) {
      acc.leafs.push(node as HierarchyRectangularNode<LeafNode>);
    }
    return acc;
  }, splitNodes);
};
